import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import AdminHeader from "../components/AdminHeader";
import { Trash2, Plus } from "lucide-react";

export default function Playlists() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [spotifyId, setSpotifyId] = useState("");

  const load = () => api.get("/playlists").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const parseId = (v) => {
    const m = v.match(/playlist[/:]([a-zA-Z0-9]+)/);
    return m ? m[1] : v.trim();
  };

  const add = async () => {
    if (!name.trim() || !spotifyId.trim()) { toast.error("Enter name and Spotify playlist link/ID"); return; }
    await api.post("/playlists", { name: name.trim(), spotify_id: parseId(spotifyId), color: "primary" });
    setName(""); setSpotifyId("");
    toast.success("Playlist added");
    load();
  };

  const remove = async (p) => {
    if (!window.confirm(`Remove "${p.name}"?`)) return;
    await api.delete(`/playlists/${p.id}`);
    load();
  };

  const inputCls = "h-14 rounded-xl bg-[#09090B] border border-white/10 px-4 text-white outline-none focus:border-[#FF007F]";

  return (
    <div className="min-h-screen bg-[#09090B] p-4 md:p-6">
      <AdminHeader title="PLAYLISTS" accent="#00F0FF" />
      <div className="bg-[#18181B] border border-white/10 rounded-2xl p-5 mb-6 grid grid-cols-1 md:grid-cols-[1fr_1.5fr_auto] gap-3">
        <input data-testid="playlist-name-input" className={inputCls} placeholder="Playlist name (e.g. YAZ Chill)" value={name} onChange={(e) => setName(e.target.value)} />
        <input data-testid="playlist-id-input" className={inputCls} placeholder="Spotify playlist link or ID" value={spotifyId} onChange={(e) => setSpotifyId(e.target.value)} />
        <button data-testid="add-playlist-button" onClick={add}
          className="h-14 px-6 rounded-xl bg-[#FF007F] text-white font-display font-black tracking-wide flex items-center justify-center gap-2 active:scale-95 transition-transform duration-75">
          <Plus className="w-6 h-6" /> ADD
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map((p) => (
          <div key={p.id} data-testid={`playlist-row-${p.id}`} className="bg-[#18181B] border border-white/10 rounded-2xl p-5 flex items-center justify-between">
            <div>
              <div className="font-display font-black text-xl text-white">{p.name}</div>
              <div className="text-[#71717A] text-xs mt-1 font-mono">{p.spotify_id}</div>
            </div>
            <button data-testid={`delete-playlist-${p.id}`} onClick={() => remove(p)}
              className="w-11 h-11 rounded-lg bg-[#27272A] hover:bg-[#FF3B30] text-white flex items-center justify-center active:scale-95 transition-transform duration-75">
              <Trash2 className="w-5 h-5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
